import { render, staticRenderFns } from "./ManualLocationEditComponent.vue?vue&type=template&id=2aa8a88d"
import script from "./ManualLocationEditComponent.vue?vue&type=script&lang=ts"
export * from "./ManualLocationEditComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports